import { Controller as DarkMode } from "../dark-mode/Controller";
import { Controller as GrayScale } from "./Controller";

export default class GrayScaleHandler {
  constructor() {
    this.thisHTML = document.querySelector('html');
    this.form = document.querySelector('#toggle-gray-scale');
    this.grayScale = new GrayScale();
    this.darkMode = new DarkMode();

    if (!this.form) {
      alert('No form found');
      return;
    }

    this.trigger = this.form.querySelector('#enable-gray-scale');
    this.triggerSwitch = this.form.querySelector('.input-toggle-switch');

    if (this.trigger) {
      this.trigger.addEventListener('change', this.toggle.bind(this));
    }
    if (this.triggerSwitch) {
      this.triggerSwitch.addEventListener('click', this.toggleSwitch.bind(this));
    }

    this.checkLocalStorage();

  }

  toggle(event) {

    event.preventDefault();

    if (!this.thisHTML.getAttribute('data-gray-scale') || this.thisHTML.getAttribute('data-gray-scale') !== 'enabled') {;
      this.darkMode.disable();
      this.grayScale.enable();
    } else {
      this.grayScale.disable();
    }

  }

  toggleSwitch(event) {
    event.preventDefault();
    this.trigger.click();
  }

  checkLocalStorage() {
    const grayScale = localStorage.getItem('gray-scale');
    if (grayScale === 'enabled') {
      this.grayScale.enable();
      this.darkMode.disable();
    }
  }

}